import * as React from 'react'
import { useNavigate } from 'react-router-dom'

import moment from 'moment'

import { useEffect } from 'modules/core/hooks/useEffect'
import { useNavigation } from 'modules/core/hooks/useNavigation'
import { useStrictParams } from 'modules/core/hooks/useStrictParams'
import { track, trackingEvents } from 'modules/core/lib/Tracking'

import DiscardedEmployees from 'modules/attendance/components/TimeTracking/Modals/DiscardedEmployees'

const ExcludePeriodsModalPage = () => {
  const { navigation } = useNavigation()
  const navigate = useNavigate()
  const { periodType, year, month, day } = useStrictParams<
    'periodType' | 'year' | 'month' | 'day'
  >()

  const onClose = () => {
    navigate(
      navigation.timeTracking.list.periodTypeYearMonthDay.fullPath({
        periodType,
        year,
        month,
        day,
      })
    )
  }

  useEffect(() => {
    track(trackingEvents.timeTracking.excludeEmployeesTimeTrackingStart)
  }, [])

  const currentMonth = moment([Number(year), Number(month) - 1, 1])

  return <DiscardedEmployees onClose={onClose} currentMonth={currentMonth} />
}

export default ExcludePeriodsModalPage
